module.exports = __webpack_public_path__ + "static/media/dany_specification_en.c685189f.md";